module.exports = __webpack_public_path__ + "img/TEA_HOUSE.0ebfc6ea.png";